export default __webpack_public_path__ + "static/media/inProgressMeter.5dc7e1a2.svg";